// removed by extract-text-webpack-plugin
module.exports = {"searchbar":"searchbar__1D_D36415MDh","button":"button__2G2f3bjsq3WH"};